'use strict';

window.VariationsWidget = window.VariationsWidget || {};
const { VariationsWidget } = window;

const { h, render } = require('phy');
const optionDetails = require('./option_details');
const Traits = require('../components/Traits.js');

VariationsWidget.init = ({ buyButtonForm = {}, variations }, done) => {
  const data = variations || buyButtonForm.variations;
  if (data) {
    render(
      h(Traits, data),
      document.getElementById('variation-container'),
      document.getElementById('variation-selector-widget')
    );
  }

  if (buyButtonForm.variations) {
    optionDetails(buyButtonForm);
  }

  return done();
};

module.exports = VariationsWidget;
